import styled from 'styled-components';

import Text from '../../../../shared/Text';
import {
  Item,
  IconContainer,
  ColorDot,
  Name,
} from '../../shared/ItemStyledComponents';
import { TrashIcon, PencilIcon, IconGroup } from '../../shared/Icons';

export const TopicItem = ({
  topic,
  setItem,
  setOpenEditModal,
  setOpenDeleteModal,
}) => {
  return (
    <Topic key={topic.value}>
      <Name>
        <ColorDot color={topic.color} />
        <Text>{topic.label}</Text>
      </Name>
      <IconGroup>
        <IconContainer
          onClick={() => {
            setItem(topic);
            setOpenEditModal(true);
          }}
        >
          <PencilIcon />
        </IconContainer>
        <IconContainer
          onClick={() => {
            setItem(topic);
            setOpenDeleteModal(true);
          }}
        >
          <TrashIcon />
        </IconContainer>
      </IconGroup>
    </Topic>
  );
};

const Topic = styled(Item)`
  grid-template-columns: 1fr 1fr;
`;
